import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import { Provider } from './ResponsiveContext';

import defaultQueries from './queries';

export default class ResponsiveProvider extends PureComponent {
  static propTypes = {
    detailed: PropTypes.bool,
    simple: PropTypes.bool,
    once: PropTypes.bool,
    queries: PropTypes.shape({
      Xl: PropTypes.string.isRequired,
      Lg: PropTypes.string.isRequired,
      Md: PropTypes.string.isRequired,
      Sm: PropTypes.string.isRequired,
      Xs: PropTypes.string.isRequired
    })
  };

  static defaultProps = {
    detailed: false,
    simple: false,
    once: false,
    queries: defaultQueries
  };

  constructor(props) {
    super(props);

    const state = {};

    const { queries } = this.props;

    Object.keys(queries).forEach(query => {
      // construct media queries
      const matchMedia = window.matchMedia(queries[query]);

      // store media query references
      this[`is${query}`] = matchMedia;

      // initialize media queries
      state[`is${query}`] = matchMedia.matches;
    });

    this.state = state;
  }

  componentDidMount() {
    const { once, queries } = this.props;

    // subscribe to changes in media queries
    if (!once)
      Object.keys(queries).forEach((query, index) =>
        this[`is${query}`].addListener(this.handleQuery[index])
      );
  }

  componentWillUnmount() {
    const { once, queries } = this.props;

    // remove media query subscriptions
    if (!once)
      Object.keys(queries).forEach((query, index) =>
        this[`is${query}`].removeListener(this.handleQuery[index])
      );
  }

  handleQuery = Object.keys(this.props.queries).map(query => ({ matches }) =>
    this.setState({ [`is${query}`]: matches })
  );

  render() {
    const { isXl, isLg, isMd, isSm, isXs } = this.state;

    const { detailed, simple, once, queries, ...props } = this.props;

    let value;

    const isDesktop = isXl || isLg;
    const isTablet = isMd;
    const isMobile = isSm || isXs;

    if (detailed) value = { isXl, isLg, isMd, isSm, isXs };
    else if (simple) value = { isDesktop, isTablet, isMobile };
    else value = { isDesktop: !isMobile, isMobile };

    // mock provider when testing
    if (process.env.NODE_ENV === 'test')
      return <div {...props} {...{ value }} />;

    return <Provider {...props} {...{ value }} />;
  }
}



// WEBPACK FOOTER //
// ./src/lib/ResponsiveProvider.js